"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorComponent = void 0;
const react_1 = __importDefault(require("react"));
const react_components_1 = require("@cimpress/react-components");
exports.ErrorComponent = (props) => {
    var _a;
    if (!props.error) {
        return null;
    }
    let rels;
    const getRels = (hasPermissionDeniedErrors) => {
        let relsPresent = true;
        rels = Object.keys(hasPermissionDeniedErrors
            .map((e, i) => e.rels)
            .reduce((acc, curr) => {
            if (curr) {
                acc[curr] = acc[curr] ? 1 : acc[curr]++;
            }
            else {
                relsPresent = false;
            }
            return acc;
        }, {}));
        return relsPresent && (rels && rels.length > 0);
    };
    const error = props.error;
    let component;
    if (error.response) {
        if (error.response.status) {
            if (error.response.status === 404) {
                return react_1.default.createElement(react_components_1.Alert, { type: 'danger', message: props.t('errors.template-not-found') });
            }
            if (error.response.status === 403) {
                return react_1.default.createElement(react_components_1.Alert, { type: 'danger', message: props.t('errors.no_access_to_this_template_title') });
            }
            if (error.response.status === 400) {
                const err = error.response.body.errors;
                try {
                    const hasPermissionDeniedErrors = err.filter((a) => a.expandedResponseCode === 403);
                    if (hasPermissionDeniedErrors.length > 0) {
                        return react_1.default.createElement(react_components_1.Alert, { type: 'warning', dismissible: false, title: props.t('errors.not_enough_permissions_title'), message: react_1.default.createElement("div", null,
                                react_1.default.createElement("br", null),
                                props.t(getRels(hasPermissionDeniedErrors)
                                    ? 'errors.not_enough_permission_description_concrete'
                                    : 'errors.not_enough_permissions_description'),
                                react_1.default.createElement("ul", null, rels.map((k) => react_1.default.createElement("li", { key: k },
                                    react_1.default.createElement("a", null, k))))) });
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-console
                    console.error(e);
                    return;
                }
            }
        }
        if ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) {
            component = JSON.stringify(error.response.data);
        }
        else {
            component = JSON.stringify(error.response);
        }
    }
    else if (error === null || error === void 0 ? void 0 : error.message) {
        component = JSON.stringify(error.message);
    }
    else {
        component = JSON.stringify(error);
    }
    return react_1.default.createElement(react_components_1.Alert, { type: 'danger', message: component });
};
//# sourceMappingURL=errorComponent.js.map